export default "__VITE_ASSET__6hMrUQ3v__"